<template>
  <!-- 出库单详情（新增/编辑/查看 -- 路桥版本） -->
  <div class="out-stock-detail">
    <list-page :status-name="dataDetail.statusName" :status-type="dataDetail.status === 1001? 'info': 'success'">
      <div class="form-div">
        <form-tag label="单据信息"/>
        <form-items :columns="3" :data="dataDetail">
          <form-item label="单据编号">
            <el-input v-model="dataDetail.billNo" placeholder="系统自动生成" disabled/>
          </form-item>
          <form-item label="出库类型" :required="true" name="billType" error-message="请选择出库类型">
            <el-select v-model="dataDetail.billType" placeholder="请选择出库类型">
              <el-option v-for="t in billTypeOptions" :key="t.code" :value="t.code" :label="t.name"/>
            </el-select>
          </form-item>
          <form-item label="单据日期">
            <el-date-picker v-model="dataDetail.billDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%"/>
          </form-item>
          <form-item label="仓库" :required="true" name="warehouseId" error-message="请选择仓库">
            <el-select v-model="dataDetail.warehouseId" placeholder="请选择仓库">
              <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
            </el-select>
          </form-item>
          <form-item label="经手人">
            <employee-select v-model="dataDetail.handlerId" :disabled="isReadonly || dataDetail.status === 2"
                             @change="handlerChange"/>
          </form-item>
          <form-item label="操作员">
            <el-input v-model="dataDetail.operatorName" disabled/>
          </form-item>
          <form-item label="部门">
            <depart-select v-model="dataDetail.departCode" :data="departTree" :disabled="isReadonly || dataDetail.status === 2" placeholder="请选择部门"/>
          </form-item>
          <!--
            路桥定制字段：存 od_stock_order 的备用字段（领料单位 bankup_1 = 施工班组、
            项目 bankup_2、审核 bankup_3、发料 bankup_4、领料人员 bankup_5 = 劳务人员）。
            班组/项目/劳务人员在 luqiao 库、职员在 basedata 库，与 order 库是不同服务，
            后端没法 join，选项列表各自拉回前端。
          -->
          <form-item label="领料单位">
            <el-select v-model="dataDetail.bankup1" :disabled="isReadonly || dataDetail.status === 2"
                       placeholder="请选择领料单位" clearable filterable style="width: 100%">
              <el-option v-for="c in classmateList" :key="c.id" :value="c.id" :label="c.classmateName"/>
            </el-select>
          </form-item>
          <form-item label="项目名称">
            <el-select v-model="dataDetail.bankup2" :disabled="isReadonly || dataDetail.status === 2"
                       placeholder="请选择项目" clearable filterable style="width: 100%">
              <el-option v-for="p in projectList" :key="p.id" :value="p.id" :label="p.projectName"/>
            </el-select>
          </form-item>
          <form-item label="审核人员">
            <employee-select v-model="dataDetail.bankup3" :disabled="isReadonly || dataDetail.status === 2"/>
          </form-item>
          <form-item label="发料人员">
            <employee-select v-model="dataDetail.bankup4" :disabled="isReadonly || dataDetail.status === 2"/>
          </form-item>
          <form-item label="领料人员">
            <el-select v-model="dataDetail.bankup5" :disabled="isReadonly || dataDetail.status === 2"
                       placeholder="请选择领料人员" clearable filterable style="width: 100%">
              <el-option v-for="w in workerList" :key="w.id" :value="w.id" :label="w.contractName"/>
            </el-select>
          </form-item>
          <!--
            路桥定制：合同编号
            1) 可以手工录入；2) 也可以从采购合同台账选一个合同，选中后把该合同的商品带到明细里（快捷添加，可再修改）；
            3) 合同编号要同步到所有明细行（od_stock_order_item.bankup_7），后续按它累计合同台账的出入库数量。
          -->
          <form-item label="合同编号">
            <div class="contract-row">
              <el-input v-model="dataDetail.bankup6" :disabled="isReadonly || dataDetail.status === 2"
                        placeholder="请输入合同编号" clearable @change="syncContractToItems" @clear="syncContractToItems">
                <template #append>
                  <page-button el-type="primary" size="small" :disabled="isReadonly || dataDetail.status === 2"
                               @click="openContractDialog">选择合同</page-button>
                </template>
              </el-input>
            </div>
          </form-item>
          <!-- 路桥定制：领料人签字（小程序手写签名后上传，存 bankup_7，这里只做回显） -->
          <form-item label="领料人签字" v-if="dataDetail.bankup7">
            <el-image :src="dataDetail.bankup7" :preview-src-list="[dataDetail.bankup7]" :preview-teleported="true"
                      fit="contain" class="signature-image"/>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input type="textarea" v-model="dataDetail.remark" placeholder="备注信息"/>
          </form-item>
        </form-items>
        <form-tag label="明细信息"/>
      </div>
      <list-table class="list-table" background-color="#FFF">
        <!-- 路桥定制：repeat-able 允许同一商品添加多行（不受通用组件的去重限制） -->
        <product-select-table ref="itemTable" v-model="dataDetail.items" :query-api="queryProductByPartner" :multi="true" :repeat-able="true" @table-select-multi="addList2Items">
          <!-- 路桥定制：物资类别/商品规格取自商品表，只读展示 -->
          <yq-table-column label="物资类别" prop="productCategoryId" width="140rem">
            <template v-slot="{row}">{{ categoryName(row.productCategoryId) }}</template>
          </yq-table-column>
          <yq-table-column label="商品规格" prop="productSpec" width="140rem">
            <template v-slot="{row}">{{ row.productSpec || "—" }}</template>
          </yq-table-column>
          <!-- 路桥定制：合同编号（默认同步单据头的合同号，允许单行修改，存 bankup_7） -->
          <yq-table-column label="合同编号" prop="bankup7" width="200rem">
            <template v-slot="{row}">
              <el-input v-model="row.bankup7" placeholder="合同编号" :disabled="isReadonly" clearable/>
            </template>
          </yq-table-column>
          <!-- 路桥定制：成分/用途/使用部位存明细的 bankup_1 ~ bankup_3，手工填写 -->
          <yq-table-column label="成分" prop="bankup1" width="140rem">
            <template v-slot="{row}">
              <el-input v-model="row.bankup1" placeholder="请输入成分" :disabled="isReadonly"/>
            </template>
          </yq-table-column>
          <yq-table-column label="用途" prop="bankup2" width="140rem">
            <template v-slot="{row}">
              <el-input v-model="row.bankup2" placeholder="请输入用途" :disabled="isReadonly"/>
            </template>
          </yq-table-column>
          <yq-table-column label="使用部位" prop="bankup3" width="140rem">
            <template v-slot="{row}">
              <el-input v-model="row.bankup3" placeholder="请输入使用部位" :disabled="isReadonly"/>
            </template>
          </yq-table-column>
          <yq-table-column label="批次号" prop="batchNumber" width="160rem">
            <template v-slot="{row}">
              <el-input v-model="row.batchNumber" placeholder="批次号（可选）" :disabled="isReadonly"/>
            </template>
          </yq-table-column>
          <yq-table-column label="单位" width="120rem" align="center">
            <template v-slot="{row}">
              <el-select v-model="row.skuUnitId" :disabled="isReadonly" placeholder="请选择单位" @change="rowQtyChange(row)" style="width:100%">
                <el-option v-for="u in row.units" :key="u" :value="u" :label="unitName(u)"/>
              </el-select>
            </template>
          </yq-table-column>
          <yq-table-column label="数量" prop="skuQty" width="130rem">
            <template v-slot="{row}">
              <!-- 路桥定制：数量允许负数（反冲：领用和归还都在出库单操作），0 不允许提交 -->
              <el-input-number v-model="row.skuQty" :min="-999999" controls-position="right" :disabled="isReadonly" style="width:100%" @change="rowPriceOrQtyChange(row)"/>
            </template>
          </yq-table-column>
          <yq-table-column label="单位价格" prop="skuPrice" width="130rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.skuPrice" :min="0" :precision="2" controls-position="right" :disabled="isReadonly" style="width:100%" @change="rowPriceOrQtyChange(row)"/>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位数量" prop="qty" width="120rem" align="right">
            <template v-slot="{row}">
              <span>{{row.qty}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位单价" prop="price" width="130rem" />
          <yq-table-column label="金额" prop="amount" width="120rem" align="right">
            <template v-slot="{row}">{{formatAmount(row)}}</template>
          </yq-table-column>
          <!-- 路桥定制：明细备注 -->
          <yq-table-column label="备注" prop="remark" width="160rem">
            <template v-slot="{row}">
              <el-input v-model="row.remark" placeholder="备注（可选）" :disabled="isReadonly"/>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" width="90rem" align="center" v-if="!isReadonly">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteItem($index)">移除</table-button>
            </template>
            <template #header>
              <table-button :disabled="isReadonly" @click="addItem"><yq-icon name="element-ui_plus"/>添加明细</table-button>
            </template>
          </yq-table-column>
        </product-select-table>

        <template v-if="hasSerialProduct">
          <form-tag label="序列号（商品开启序列号时填写）"/>
          <list-table>
            <div class="serial-input-area">
              <el-input v-model="serialInput" placeholder="扫码 / 输入序列号后回车添加" :disabled="isReadonly"
                        @keydown.enter="addSerial"/>
              <div class="serial-tags">
                <span class="serial-tag" v-for="(s, i) in dataDetail.serialList || []" :key="i">
                  {{s}}
                  <yq-icon v-if="!isReadonly" name="element-ui_close" @click="dataDetail.serialList.splice(i, 1)"/>
                </span>
              </div>
            </div>
            <div class="tip-warn">⚠️ 出库序列号必须为当前库存中存在的序列号，出库后自动核销。</div>
          </list-table>
        </template>
      </list-table>

      <form-page :show-page="false" v-if="!isReadonly">
        <template #left>单据金额: {{dataDetail.totalAmount}}</template>
        <print-button v-if="!!dataDetail.id" template-key="LUQIAO_OUT_STOCK" :find-print-data="getDetail" class="print-button">打印</print-button>
        <page-button :disabled="dataDetail.status > 1001" type="write" el-type="primary" @click="saveData">保存草稿</page-button>
        <page-button :disabled="dataDetail.status > 1001" type="write" el-type="success" @click="submitData">提交单据</page-button>
        <page-button @click="router.go(-1)">取消</page-button>
      </form-page>
    </list-page>

    <!-- 选择采购合同：搜索 + 列表，选中后把合同商品带到明细 -->
    <el-dialog v-model="showContractDialog" title="选择采购合同" width="900px" append-to-body
               :close-on-click-modal="false">
      <div class="contract-search">
        <el-input v-model="contractSearchKey" placeholder="请输入采购合同编号" clearable
                  @keydown.enter="searchContracts" @clear="searchContracts">
          <template #prefix>合同编号</template>
        </el-input>
        <page-button type="read" el-type="primary" @click="searchContracts">查询</page-button>
      </div>
      <yq-table :data="contractDialogList" height="420px" border stripe v-loading="contractLoading"
                empty-text="没有查询到采购合同">
        <yq-table-column label="合同编号" prop="contractNumber" min-width="220rem" :show-overflow-tooltip="true"/>
        <yq-table-column label="物资清单" prop="productCount" width="120rem" align="center">
          <template v-slot="{row}">{{row.productCount || 0}} 个商品</template>
        </yq-table-column>
        <yq-table-column label="总数量" prop="totalQty" width="120rem" align="right">
          <template v-slot="{row}">{{qtyText(row.totalQty)}}</template>
        </yq-table-column>
        <yq-table-column label="入库/出库" prop="inStockQty" width="160rem" align="center">
          <template v-slot="{row}">{{qtyText(row.inStockQty)}} / {{qtyText(row.outStockQty)}}</template>
        </yq-table-column>
        <yq-table-column label="操作" width="100rem" align="center">
          <template v-slot="{row}">
            <table-button @click="selectContract(row)">选择</table-button>
          </template>
        </yq-table-column>
      </yq-table>
      <template #footer>
        <page-button @click="showContractDialog = false">取消</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import YqIcon from "@/components/YqIcon.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import CustomerSelect from "@/components/h5/partner/CustomerSelect.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import commonApi from "@/api/commonApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import outboundOrderApi from "@/api/normal/stock/outboundOrderApi";
import luqiaoCommonApi from "@/api/dz-luqiao/luqiaoCommonApi";
import purchaseContractApi from "@/api/dz-luqiao/purchaseContractApi";
import PrintButton from "@/views/h5/common/print/template/print-button.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "OutStockDetail",
  components: {
    PrintButton,
    YqIcon, YqTable, ProductSelectTable, YqTableColumn, TableButton, FormItems, FormItem, FormTag,
    EmployeeSelect, DepartSelect, CustomerSelect,
    PageButton, ListPage, ListTable, FormPage
  },
  data() {
    return {
      billTypeOptions: [],
      warehouseOptions: [],
      unitList: [],
      departTree: [],
      dataDetail: {},
      serialInput: "",
      isReadonly: false,
      userInfo: {},
      // 路桥定制：领料单位(班组)/项目/领料人员(劳务人员)下拉 + 物资类别名称
      classmateList: [],
      projectList: [],
      workerList: [],
      categoryList: [],
      // 路桥定制：采购合同台账里的合同号，选中后把合同商品带到明细
      // 路桥定制：选择采购合同弹窗（搜索 + 列表）
      showContractDialog: false,
      contractSearchKey: "",
      contractDialogList: [],
      contractLoading: false,
    };
  },
  computed: {
    hasSerialProduct() {
      return (this.dataDetail.items || []).some(it => it.serialEnabled === 1);
    }
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    // 不使用页面缓存
    this.userInfo = await Util.getUserInfo();
    this.init();
    let id = this.route.query.id;
    if (id) {
      this.isReadonly = this.route.query.view === '1';
      this.findById(id);
    } else {
      this.initNew();
    }
    Util.getSystemSettingOptions("STOCK_OUT_TYPE").then(list => this.billTypeOptions = list);
  },
  methods: {
    /**
     * 打印数据组装（print-button 的 find-print-data 入口）
     *
     * ★ 表体必须挂在 table1 下：模板里 tableField('table1', ...) 的元素 field 是 table1，
     *   detailField(...) 的 dataSource 默认也是 table1，渲染器就是按这两个键取数组的。
     *
     * 字段名与 luqiao_out_stock_template.js 的 textFields / detailFields 一一对应。
     * 领料单位/项目/领料人员在 luqiao 库、职员在 basedata 库，与 order 库是不同服务，
     * 名称只能在这里按 id 关联（本页的下拉数据里已经有班组/项目/劳务人员）。
     */
    async getDetail() {
      const detail = this.dataDetail || {};
      const items = detail.items || [];

      // 审核(bankup3)/发料(bankup4) 存的是职员id，本页没有职员列表，按 id 批量查回姓名
      const employeeIds = [detail.bankup3, detail.bankup4].filter(Boolean);
      const employeeNameMap = {};
      if (employeeIds.length) {
        const employees = await commonApi.queryEmployeeByIds(employeeIds).catch(() => []) || [];
        employees.forEach(employee => employeeNameMap[employee.id] = employee.employeeName);
      }

      return {
        classmateName: this.pickName(this.classmateList, detail.bankup1, "classmateName"),
        projectName: this.pickName(this.projectList, detail.bankup2, "projectName"),
        billDate: detail.billDate ? String(detail.billDate).slice(0, 10) : "",
        warehouseName: this.warehouseNameOf(detail.warehouseId),
        contractName: detail.bankup6 || "",
        checkName: employeeNameMap[detail.bankup3] || "",
        acceptName: employeeNameMap[detail.bankup4] || "",
        contractWorkerName: this.pickName(this.workerList, detail.bankup5, "contractName"),
        // 二维码：内容为「单据查看页」的完整地址（所有库存单据共用一个页面）
        qrcode: this.buildOrderViewUrl(detail),
        // 表体：键必须是 table1（原因见上）
        table1: items.map((item, index) => ({
          index: index + 1,
          productCategoryName: item.productCategoryId ? this.categoryName(item.productCategoryId) : "",
          productName: item.productName || "",
          specifications: item.productSpec || "",
          displayUnitName: this.unitName(item.skuUnitId),
          composition: item.bankup1 || "",
          displayQty: item.skuQty != null ? item.skuQty : item.qty,
          price: item.skuPrice != null ? item.skuPrice : item.price,
          amount: item.amount,
          // 用途/使用部位 = 明细备用字段 bankup2 / bankup3，字段名与模板的 detailFields 一致
          purpose: item.bankup2 || "",
          usePart: item.bankup3 || "",
          remark: item.remark || "",
        })),
      };
    },
    /**
     * 单据查看页的完整地址，供二维码使用（所有库存单据共用一个页面）
     *
     * ★ 渲染器取值走 valueResolver.resolveCodeValue → getFieldValue(data, el.field)，
     *   也就是按「二维码元素上配置的字段名」直接取，所以设计器里那个二维码元素的字段要填成 qrCode。
     *
     * ★ 用 window.location.origin 取当前系统地址（协议+域名+端口），路由是 history 模式、部署在根路径，
     *   拼上 /stock/order/view 即可；employeeId 取当前登录职员，merchantId 优先用单据自己的。
     */
    buildOrderViewUrl(detail) {
      const origin = window.location.origin;
      const orderId = detail.id || "";
      const employeeId = this.userInfo.id || "";
      const merchantId = detail.merchantId || this.userInfo.merchantId || "";
      return `${origin}/stock/order/view?id=${orderId}&employeeId=${employeeId}&merchantId=${merchantId}`;
    },
    /** 按 id 在列表里取名称，找不到返回空串（打印数据里空串比 id 好，至少不误导） */
    pickName(list, id, nameField) {
      if (!id) {
        return "";
      }
      const hit = list.find(item => String(item.id) === String(id));
      return hit ? hit[nameField] : "";
    },
    /** 发货库房：按仓库下拉取名称 */
    warehouseNameOf(warehouseId) {
      if (!warehouseId) {
        return "";
      }
      const hit = this.warehouseOptions.find(w => String(w.id) === String(warehouseId));
      return hit ? hit.warehouseName : "";
    },
    // 查询商品列表，用于下单，包含价格方案
    queryProductByPartner(data) {
      return new Promise(resolve => {
        commonDataApi.queryProductListByPartner({
          ...data,
          partnerId: this.dataDetail.customerId
        }).then(res => resolve(res))
      })
    },
    init() {
      // 仓库/单位下拉 + 部门树
      commonDataApi.queryAllWarehouse().then(warehouses => {
        this.warehouseOptions = warehouses || [];
        // 主部门唯一仓库自动选中
        if (this.warehouseOptions.length === 1) {
          this.dataDetail.warehouseId = this.warehouseOptions[0].id;
          return;
        }
        let count = 0;
        let warehouseId = "";
        for (let i = 0; i < this.warehouseOptions.length; i++) {
          if (this.userInfo.mainDepartCode === this.warehouseOptions[i].departCode) {
            count++;
            warehouseId = this.warehouseOptions[i].id;
          }
        }
        if (count === 1) {
          this.dataDetail.warehouseId = warehouseId;
        }
      });
      commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(units => this.unitList = units || []);
      commonApi.queryDepartList().then(departs => this.departTree = departs || []);
      // 路桥定制：领料单位/项目/领料人员选项 + 物资类别（商品分类）字典
      luqiaoCommonApi.queryClassmateNoPage().then(list => this.classmateList = list || []);
      luqiaoCommonApi.queryProjectNoPage().then(list => this.projectList = list || []);
      luqiaoCommonApi.queryWorkersNoPage().then(list => this.workerList = list || []);
      commonApi.queryDictionaryList("PRODUCT_CATEGORY").then(list => this.categoryList = list || []);
    },
    /** 打开采购合同弹窗：默认按当前已填的合同号查一次 */
    openContractDialog() {
      if (this.isReadonly || this.dataDetail.status === 2) {
        return;
      }
      this.contractSearchKey = this.dataDetail.bankup6 || "";
      this.contractDialogList = [];
      this.showContractDialog = true;
      this.searchContracts();
    },
    /** 按合同编号搜索采购合同台账（空条件查全部） */
    async searchContracts() {
      this.contractLoading = true;
      try {
        this.contractDialogList = await purchaseContractApi.queryContractNoPage({searchKey: this.contractSearchKey}) || [];
      } finally {
        this.contractLoading = false;
      }
    },
    /** 选中合同：回填合同编号，并把合同下的商品带到明细 */
    selectContract(row) {
      this.showContractDialog = false;
      this.dataDetail.bankup6 = row.contractNumber;
      this.chooseContract(row.contractNumber);
    },
    /** 数量显示：去掉多余的小数位 */
    qtyText(value) {
      if (value === null || value === undefined || value === "") {
        return "0";
      }
      return String(Number(value));
    },
    /**
     * 选择采购合同：把合同下的商品追加到明细（快捷添加，添加后可以像普通明细一样修改）
     *
     * ★ 只带商品和合同数量/单价，不覆盖已有明细；合同号统一由 syncContractToItems 写到每一行。
     */
    async chooseContract(contractNumber) {
      this.syncContractToItems();
      if (!contractNumber) {
        return;
      }
      const rows = await purchaseContractApi.queryItemList(contractNumber);
      if (!rows || !rows.length) {
        this.$message.warning("该合同下没有物资明细");
        return;
      }
      rows.forEach(row => {
        this.dataDetail.items.push(this.buildContractItem(row, contractNumber));
      });
      this.syncContractToItems();
      // 商品选择组件内部维护着同一个明细数组，新增行后通知它刷新
      this.$refs.itemTable.refresh();
    },
    /** 采购合同明细 → 出库单明细行（商品id 用 skuId，字段与一行行添加商品一致） */
    buildContractItem(row, contractNumber) {
      const qty = Number(row.qty) || 0;
      const price = Number(row.price) || 0;
      const units = [row.unitId, row.unitIdMiddle, row.unitIdLarge].filter(Boolean);
      return {
        skuId: row.productId,
        productId: row.productId,
        productName: row.productName || "",
        productCategoryId: row.categoryId,
        productSpec: row.spec,
        unitIdBase: row.unitId,
        unitIdMiddle: row.unitIdMiddle,
        unitIdLarge: row.unitIdLarge,
        middleRate: row.middleRate,
        largeRate: row.largeRate,
        units: units,
        // 出库用售价：把合同单价作为基本单位售价，换单位时不会把价格清成 0
        salePriceBase: price,
        skuUnitId: row.unitId,
        skuQty: qty,
        skuPrice: price,
        qty: qty,
        price: price,
        amount: row.amount != null ? Number(row.amount) : qty * price,
        batchNumber: "",
        // 合同号同步到明细备用字段，后续按它累计台账的出入库数量
        bankup7: contractNumber,
      };
    },
    /** 合同编号同步到所有明细行（od_stock_order_item.bankup_7） */
    syncContractToItems() {
      const contractNumber = this.dataDetail.bankup6 || "";
      (this.dataDetail.items || []).forEach(item => item.bankup7 = contractNumber);
      if (this.$refs.itemTable) {
        this.$refs.itemTable.refresh();
      }
    },
    /** 物资类别：明细带的是商品分类的字典值，名称由前端关联 */
    categoryName(categoryId) {
      if (!categoryId) {
        return "—";
      }
      const hit = this.categoryList.find(c => String(c.dictCode) === String(categoryId));
      return hit ? hit.dictName : categoryId;
    },
    // 经手人 change 事件回填名称
    handlerChange(data) {
      this.dataDetail.handlerName = (data && data.employeeName) || "";
    },
    unitName(unitId) {
      if (!unitId) return "";
      let u = this.unitList.find(it => it.dictCode === unitId);
      return u ? u.dictName : "";
    },
    formatAmount(row) {
      let amount = row.amount != null ? Number(row.amount) : ((Number(row.skuQty) || 0) * (Number(row.skuPrice) || 0));
      return amount.toFixed(2);
    },
    async findById(id) {
      const res = await outboundOrderApi.findById(id);
      this.dataDetail = res;
      this.dataDetail.items = (res.itemList || []).map(it => {
        const row = {
          skuId: it.skuId || it.productId,
          productId: it.productId,
          productName: it.productName || "",
          unitIdBase: it.unitIdBase || it.skuUnitId,
          unitIdMiddle: it.unitIdMiddle,
          unitIdLarge: it.unitIdLarge,
          batchNumber: it.batchNumber,
          skuUnitId: it.skuUnitId || it.unitIdBase,
          skuQty: it.skuQty != null ? it.skuQty : it.qty,
          skuPrice: it.skuPrice != null ? it.skuPrice : it.price,
          qty: it.qty,
          price: it.price,
          amount: it.amount,
          // 路桥定制：物资类别/规格（只读展示）+ 成分/用途/使用部位 + 备注
          productCategoryId: it.productCategoryId,
          productSpec: it.productSpec,
          bankup1: it.bankup1,
          bankup2: it.bankup2,
          bankup3: it.bankup3,
          // 路桥定制：采购合同号（同步自单据头的合同编号）
          bankup7: it.bankup7,
          remark: it.remark,
        };
        row.units = [row.unitIdBase, row.unitIdMiddle, row.unitIdLarge].filter(Boolean);
        return row;
      });
      if (res.serialNumber) {
        try {
          this.dataDetail.serialList = JSON.parse(res.serialNumber);
        } catch (e) {
          this.dataDetail.serialList = [];
        }
      } else {
        this.dataDetail.serialList = [];
      }
    },
    initNew() {
      // 经手人/操作员/部门默认当前用户；仓库自动选中由 init 的 queryAllWarehouse 处理
      this.dataDetail = {
        billNo: "",
        billType: 101,
        billDate: this.today(),
        customerId: "",
        warehouseId: this.dataDetail.warehouseId,
        remark: "",
        handlerId: this.userInfo.id,
        handlerName: this.userInfo.employeeName,
        operatorId: this.userInfo.id,
        operatorName: this.userInfo.employeeName,
        departCode: this.userInfo.mainDepartCode,
        // 路桥定制：领料单位/项目/审核/发料/领料人员 + 合同名称，存备用字段
        bankup1: "", bankup2: "", bankup3: "", bankup4: "", bankup5: "", bankup6: "",
        items: [{skuId: "", productId: "", productName: "", skuUnitId: "", skuQty: 1, qty: 1, batchNumber: ""}],
        serialList: [],
      };
    },
    today() {
      return new Date().toISOString().slice(0, 10);
    },
    addItem() {
      this.$refs.itemTable.toSelectMore();
    },
    addList2Items(list) {
      // 新加行的合同编号在 fillItems 里按单据头补齐，不整表覆盖（否则会冲掉用户单行改过的合同号）
      this.fillItems(this.dataDetail.items, list);
    },
    /**
     * 把选中商品的默认单位/价格回填到明细行
     *
     * ★ 允许同一商品多行：商品选择组件只会给「本次操作的行」打上 productInfo 标记
     *   （新加的行、以及被重新选择商品的当前行），这里只回填带标记的行，回填完就清掉标记。
     *   不能像以前那样按 skuId 把所有同商品的行都刷一遍 —— 再次添加同一商品时，
     *   会把已经填好数量和单价的老行重置成商品的默认值。
     */
    fillItems(items, list) {
      (items || []).forEach(item => {
        if (!item.productInfo) {
          return;
        }
        const product = (list || []).find(p => p.id === item.skuId);
        delete item.productInfo;
        if (!product) {
          return;
        }
        item.productId = product.parentId || product.id;
        item.productName = product.productName;
        item.unitIdBase = product.unitIdBase;
        item.unitIdMiddle = product.unitIdMiddle;
        item.unitIdLarge = product.unitIdLarge;
        item.middleRate = product.middleRate;
        item.largeRate = product.largeRate;
        item.units = [product.unitIdBase, product.unitIdMiddle, product.unitIdLarge].filter(Boolean);
        item.salePriceBase = product.salePriceBase || 0;
        item.salePriceMiddle = product.salePriceMiddle || 0;
        item.salePriceLarge = product.salePriceLarge || 0;
        item.serialEnabled = product.serialEnabled;
        // 路桥定制：把商品自带的类别/规格带进明细，不用等保存后才显示
        item.productCategoryId = product.categoryId;
        item.productSpec = product.spec;
        item.skuUnitId = product.unitIdBase;
        item.skuQty = item.skuQty || 1;
        item.skuPrice = product.salePriceBase || 0;
        item.qty = item.qty || 1;
        item.amount = (Number(item.skuQty) || 0) * (Number(item.skuPrice) || 0);
        // 新加的商品行默认绑定单据头的合同编号；已有值（用户改过的）不覆盖
        if (!item.bankup7) {
          item.bankup7 = this.dataDetail.bankup6 || "";
        }
        this.rowQtyChange(item);
      });
    },
    // 换单位：重算基本单位数量，并取所选单位对应的价格到 sku_price
    rowQtyChange(row) {
      if (!row) return;
      let rate = 1;
      if (row.skuUnitId && row.skuUnitId === row.unitIdMiddle && row.middleRate) {
        rate = Number(row.middleRate);
      } else if (row.skuUnitId && row.skuUnitId === row.unitIdLarge && row.largeRate) {
        rate = Number(row.largeRate);
      }
      row.qty = Number(((Number(row.skuQty) || 0) * rate).toFixed(4));
      // 取所选单位对应价格
      if (row.skuUnitId === row.unitIdMiddle) {
        row.skuPrice = Number(row.salePriceMiddle) || 0;
      } else if (row.skuUnitId === row.unitIdLarge) {
        row.skuPrice = Number(row.salePriceLarge) || 0;
      } else {
        row.skuPrice = Number(row.salePriceBase) || 0;
      }
      this.rowPriceChange(row);
    },
    rowPriceOrQtyChange(row) {
      if (!row) return;
      let rate = 1;
      if (row.skuUnitId && row.skuUnitId === row.unitIdMiddle && row.middleRate) {
        rate = Number(row.middleRate);
      } else if (row.skuUnitId && row.skuUnitId === row.unitIdLarge && row.largeRate) {
        rate = Number(row.largeRate);
      }
      row.qty = Number(((Number(row.skuQty) || 0) * rate).toFixed(4));
      this.rowPriceChange(row);
    },
    // 数量/单位价格变更：金额 = 单位数量 × 单位价格；基本单位单价 = 金额 / 基本单位数量
    rowPriceChange(row) {
      if (!row) return;
      row.amount = Number(((Number(row.skuQty) || 0) * (Number(row.skuPrice) || 0)).toFixed(4));
      if (Number(row.qty) > 0) {
        row.price = Number((row.amount / Number(row.qty)).toFixed(4));
      } else {
        row.price = 0;
      }
    },
    deleteItem(index) {
      this.dataDetail.items.splice(index, 1);
      this.$refs.itemTable.refresh();
    },
    addSerial() {
      let s = this.serialInput.trim();
      if (!s) return;
      if (!this.dataDetail.serialList) this.dataDetail.serialList = [];
      this.dataDetail.serialList.push(s);
      this.serialInput = "";
    },
    // 构建明细 + 基础校验，返回构建好的提交数据（校验失败返回 null）
    buildSubmitData() {
      if (!this.dataDetail.warehouseId) {
        this.$message.error("请选择仓库");
        return null;
      }
      const items = (this.dataDetail.items || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        skuUnitId: it.skuUnitId || it.unitIdBase,
        skuQty: it.skuQty != null ? it.skuQty : it.qty,
        skuPrice: it.skuPrice != null ? it.skuPrice : 0,
        batchNumber: it.batchNumber,
        qty: it.qty,
        price: it.price,
        amount: it.amount != null ? it.amount : (Number(it.skuQty) || 0) * (Number(it.skuPrice) || 0),
        // 路桥定制：成分/用途/使用部位(bankup_1~3)、采购合同号(bankup_7) 与明细备注必须显式带上
        bankup1: it.bankup1,
        bankup2: it.bankup2,
        bankup3: it.bankup3,
        bankup7: it.bankup7 || this.dataDetail.bankup6,
        remark: it.remark,
      }));
      if (items.length === 0) {
        this.$message.error("请添加明细");
        return null;
      }
      // 路桥定制：数量为 0 不允许提交（负数表示反冲，是允许的）
      if (items.some(it => Number(it.skuQty != null ? it.skuQty : it.qty) === 0)) {
        this.$message.error("有商品数量为 0，请填写出库数量（可为负数）");
        return null;
      }
      // 强制序列号商品校验
      if (this.hasSerialProduct && (!this.dataDetail.serialList || this.dataDetail.serialList.length === 0)) {
        this.$message.error("开启强制序列号的商品须填写序列号才能提交");
        return null;
      }
      const submitData = {...this.dataDetail, itemList: items};
      if (this.dataDetail.serialList && this.dataDetail.serialList.length > 0) {
        submitData.serialNumber = JSON.stringify(this.dataDetail.serialList);
      }
      return submitData;
    },
    // 保存草稿
    saveData() {
      const submitData = this.buildSubmitData();
      if (!submitData) return;
      submitData.status = 1001;
      outboundOrderApi.save(submitData).then(() => this.router.push('/stock/outStock'));
    },
    // 提交单据（保存后提交，校验库存并扣减）
    submitData() {
      const submitData = this.buildSubmitData();
      if (!submitData) return;
      submitData.status = 1010;
      outboundOrderApi.save(submitData).then(() => this.router.push('/stock/outStock'));
    }
  }
};
</script>

<style lang="scss" scoped>
.print-button{
  margin-right: 10px;
}
// 选择采购合同弹窗（弹框 append-to-body，样式不能嵌在 .out-stock-detail 里）
.contract-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.out-stock-detail {
  height: 100%;

  .form-div {
    padding: 10px 10px 0 10px;
    background: #FFF;
  }
  // 合同编号：手工输入 + 「选择合同」弹窗
  .contract-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  // 领料人签字（小程序签名图片回显）
  .signature-image {
    width: 180px;
    height: 80px;
    border: 1px solid var(--yq-border-color, #ebeef5);
    border-radius: 4px;
    background: #fff;
  }

  .list-table {
    padding: 10px;
  }

  .add-item-btn {
    border: 1.5px dashed var(--yq-border-color);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    color: var(--yq-font-color-tips);
    font-size: 13px;
    cursor: pointer;
    margin: 8px 16px;

    &:hover {
      color: var(--el-color-primary);
      border-color: var(--el-color-primary);
    }
  }

  .serial-input-area {
    padding: 10px 16px;

    .serial-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 10px;

      .serial-tag {
        background: var(--el-color-primary-light-9);
        color: var(--el-color-primary);
        padding: 3px 10px;
        border-radius: 4px;
        font-size: 13px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }
    }
  }

  .tip-warn {
    font-size: 12px;
    color: var(--el-color-warning);
    background: var(--el-color-warning-light-9);
    padding: 8px 12px;
    border-radius: 4px;
    margin: 0 16px 10px;
  }
}
</style>
